import React from 'react';

import { uppercase, numberWithSpaces } from '../services/utils/format'
import { useRegistrationContext } from '../contexts/registrationContext'
import { strings } from "../assets/resources/translations"
import Accordion from '../elements/Accordion'


// TODO fix nr of pax and deposit dynamically
const getSpecifications = (specification, priceSettings, total, inputs) => {

	if (!specification || specification.length === 0) {
		return ([])
	}
	return (
		<div>
			{specification.map(item => {
				return (
					<div className="breakdown-table">
						<span>{strings[item.name] || item.name} {item.quantity > 1 && <span> x {item.quantity}</span>}</span>
						<span className="total-price-cell">{item.price > 0 ? '+' : item.price < 0 ? '-' : ''} {numberWithSpaces(item.price * item.quantity)}:-</span>
						{item.quantity > 1 && <span className="ind-price-cell"> ({numberWithSpaces(item.price)}:-)</span>}
					</div>
				)
			})}
			<div className="divider" />
			<div className="breakdown-table">
				<span className="txt-bold">{strings.depositLabel}</span>
				<span className="total-price-cell txt-bold">{numberWithSpaces(priceSettings.deposit * parseInt(inputs.basic.nrOfPax))}:-</span>
			</div>
			<div className="divider" />
			<div className="breakdown-table">
				<span className="txt-bold">{strings.totalPrice}</span>
				<span className="total-price-cell txt-bold">{numberWithSpaces(total)}:-</span>
			</div>
		</div>
	)
}

const PriceSpecification = () => {
	const { price: { total, specification, priceSettings }, wrapper: { inputs } } = useRegistrationContext()
	return (
		<div className="price-specification">
			<div className="price-specification-header">
				<span className="total">{uppercase(strings.totalPrice)}:</span>
				<p className="price">{total !== 0 ? `${numberWithSpaces(total)} :-` : "-"}</p>
			</div>
			<div className="price-specification-main">
				<Accordion
					title={strings.priceSpecificationLabel}
					icon={""}
					content={getSpecifications(specification, priceSettings, total, inputs)}
				/>

			</div>
		</div>
	)
}

export default PriceSpecification